
import Vue from 'vue'
import moment from 'moment'

Vue.filter('courseType', function(type) {
  if (type == 'pos') return 'PÓS-GRADUAÇÃO'
  else return 'CURSO DE CURTA DURAÇÃO'
})

Vue.filter('checkPendency', function(value) {
  if (value == 1) return 'HÁ PENDENCIAS'
  else return 'NÃO HÁ PENDENCIAS'
})

Vue.filter('checkRole', function(role) {
  if (role == 'admin') return 'ADMINISTRADOR'
  else if (role == 'dev') return 'DESENVOLVEDOR'
  else return 'VISUALIZADOR'
})

Vue.filter('convertDate', function(date) {
  return date == null ? '' : moment.utc(date).format('DD/MM/YYYY')
})

Vue.filter('convertDateCheck', function(date) {
  return date == null ? '--' : moment.utc(date).format('DD/MM/YYYY')
})
